import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

type PropsType = {
  navigateToPreviousTab?: () => void;
  navigateToNextTab?: () => void;
  completeConstructor?: () => void;
};

export const ProjectConstructorNavigationControls = ({
  navigateToPreviousTab,
  navigateToNextTab,
  completeConstructor,
}: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });

  return (
    <>
      {navigateToPreviousTab ? (
        <Button size="large" onClick={navigateToPreviousTab}>
          {t('previous')}
        </Button>
      ) : null}
      {navigateToNextTab ? (
        <Button size="large" type="primary" onClick={navigateToNextTab}>
          {t('continue')}
        </Button>
      ) : null}
      {completeConstructor ? (
        <Button size="large" type="primary" onClick={completeConstructor}>
          {t('finish')}
        </Button>
      ) : null}
    </>
  );
};
